var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"outlined":"","rounded":"lg"}},[_c('v-data-table',{attrs:{"dense":"","headers":_vm.headers,"items":_vm.items,"hide-default-footer":"","hide-default-header":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }